import { Component, OnInit } from '@angular/core';
import { ModalSize, SuiModalService } from '@richardlt/ng2-semantic-ui';
import { AppFilter } from '@app/shared/models';
import { addNotificationModal } from '../../modals/add-notification-modal/add-notification-modal.component';
import { ConfirmModal } from '@app/shared/modals';
import { SettingsService } from '../../services/settings.service';
import { PermissionService } from '../../services/permission.service';
interface IHeaders {
  field?: string;
  label?: string;
  type?: string;
  choices?: any[];
  op?: string;
  data?: any;
}

@Component({
  selector: 'app-settings-list',
  templateUrl: './settings-list.component.html',
  styleUrls: ['./settings-list.component.scss'],
})
export class SettingsListComponent implements OnInit {
  filter: AppFilter = new AppFilter();
  pending: boolean;
  rows: number = 2;
  currentPage: number = 1;
  maxSize: number = 7;
  // users: Array<any> = [];
  success: any;
  totalItems: number;
  error: any;
  settings: any[] = [];

  constructor(
    private permissionService: PermissionService,
    private modalService: SuiModalService,
    private settingSvc: SettingsService
  ) {
    this.filter = new AppFilter({
      sidx: 'dateCreated',
      rows: 10,
      sord: 'desc',
    });

    this.getPage(1);
    this.totalItems = this.settings.length;
  }
  headerFilters: any[];
  ngOnInit(): void {}
  notificationData = [
    {
      notificationName: 'slackchannelid001',
      notificationType: 'Slack',
      createdBy: 'Tolulope Idris',
      datecreated: '17 Oct, 2020, 5:15PM',
    },
    {
      notificationName: 'slackchannelid002',
      notificationType: 'Slack',
      createdBy: 'Tolulope Idris',
      datecreated: '17 Oct, 2020, 5:15PM',
    },
    {
      notificationName: 'emailsecurity01',
      notificationType: 'Email',
      createdBy: 'Tolulope Idris',
      datecreated: '17 Oct, 2020, 5:15PM',
    },
    {
      notificationName: 'emailsecurity020',
      notificationType: 'Email',
      createdBy: 'Tolulope Idris',
      datecreated: '17 Oct, 2020, 5:15PM',
    },
  ];

  searchFilter = {
    groupOp: 'OR',
    rules: [
      {
        field: 'settingsType',
        op: 'cn',
        data: '',
      },
    ],
  };
  headers: IHeaders[] = [
    {
      field: 'settingsType',
      label: 'Notification Type',
      type: 'text',
      op: 'cn',
      data: '',
    },
  ];

  getPage(page) {
    this.filter.page = page;
    this.pending = true;
    this.settingSvc
      .getNotificationSettings({
        params: this.filter,
      })
      .subscribe(
        (res: any) => {
          this.pending = false;
          this.settings = res['rows'];
          this.totalItems = +res.records;
          this.currentPage = +res.page;
          this.rows = this.filter.rows;
        },
        (error) => {
          this.pending = false;
          this.error = error.error ? error.error : error;
        }
      );
  }
  searchRecords(search) {
    let searchFilter = {
      groupOp: 'OR',
      rules: [
        {
          field: 'settingsType',
          op: 'cn',
          data: '',
        },
      ],
    };
    searchFilter.rules[0].data = search;
    this.filter.filters = JSON.stringify(searchFilter);
    this.getPage(1);
  }

  advancedSearch(search) {
    if (search) {
      // this.filter = search;
      this.filter._search = true;
      this.filter.filters = JSON.stringify(search);
    } else {
      this.filter.filters = {};
      this.filter._search = false;
    }
    this.currentPage = 1;
    this.filter.page = this.currentPage;
    this.filter.sidx = 'dateCreated';
    this.getPage(this.currentPage);
    // console.log(this.filter);
  }

  editHeader(notification) {
    if (this.parseItem(notification.settings).notificationType == 'slack') {
      this.modalService
        .open(
          new addNotificationModal(
            'Edit Notification',
            {
              type: 'slack',
              settingId: notification.settingId,
              showEmailField: false,
              channel: this.parseItem(notification.settings).slackChannel,
              name: this.parseItem(notification.settings).name,
              description: this.parseItem(notification.settings).description,
            },
            ModalSize.Tiny
          )
        )
        .onApprove(() => {
          this.getPage(1);
        })
        .onDeny(() => {});
    }
    if (this.parseItem(notification.settings).notificationType == 'email') {
      this.modalService
        .open(
          new addNotificationModal(
            'Edit Notification',
            {
              type: 'email',
              showEmailField: true,
              settingId: notification.settingId,
              name: this.parseItem(notification.settings).name,
              description: this.parseItem(notification.settings).description,
              email: this.parseItem(notification.settings).emailAddress,
              subject: this.parseItem(notification.settings).emailSubject,
            },
            ModalSize.Tiny
          )
        )
        .onApprove(() => {
          this.getPage(1);
        })
        .onDeny(() => {});
    }
  }
  parseItem(item) {
    return JSON.parse(item);
  }
  addNotifications() {
    this.modalService
      .open(
        new addNotificationModal(
          'Add Notification',
          { isAdd: true },
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.getPage(1);
      })
      .onDeny(() => {});
  }

  sortRecords(search) {
    this.filter.sord = search;
    this.filter.sidx = 'desc';
    this.getPage(1);
  }
  cancelAd() {
    this.filter = new AppFilter({
      page: 1,
      rows: this.rows,
      _search: false,
    });
    this.getPage(1);
  }

  delete(setting) {
    this.modalService
      .open(
        new ConfirmModal(
          'Delete Notification',
          'Are you sure you want to delete this Notification?',
          ModalSize.Tiny
        )
      )
      .onApprove(() => {
        this.pending = true;
        this.settingSvc
          .deleteSetting({
            settingsId: setting.settingId,
          })
          .subscribe(
            (res) => {
              this.pending = false;
              this.success = 'Setting Deleted Succesfully';
              this.getPage(1);
            },
            (error) => {
              this.pending = false;
              this.error = error.error ? error.error : error;
            }
          );
      })
      .onDeny(() => {});
  }

  //handles rows display
  displayRecords(row) {
    this.filter['rows'] = row;
    this.getPage(1);
  }

  nextPage(page: number) {
    //get and assign current page
    this.currentPage = page;
    this.getPage(this.currentPage);
  }

  parseJSON(jsonString: string) {
    return JSON.parse(jsonString);
  }

  checkPermission(event: { id: string; action: string }): boolean {
    const { id, action } = event;
    return this.permissionService.checkPermission(id, action);
  }
}
